export const UploadInvoiceIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.0202 5.39372V2.5C12.0202 2.22386 11.7964 2 11.5202 2H3.33329C3.15648 2 2.98691 2.07024 2.86189 2.19526C2.73686 2.32029 2.66663 2.48986 2.66663 2.66667V14L4.22663 13.3333L5.77996 14L7.33329 13.3333"
            stroke="#0E76A8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.00004 10H5.33337M9.00004 7.33336H5.33337M8.00004 4.63H5.33337"
            stroke="#0E76A8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 12.4127V8.41272"
            stroke="#0E76A8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.9454 12.6829L10.8962 11.6108"
            stroke="#0E76A8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.9568 12.6715L13.0288 11.6223"
            stroke="#0E76A8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.2901 13.746H9.62341"
            stroke="#0E76A8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
